import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlashMessagesService } from 'flash-messages-angular';
import { RouteService } from 'src/app/core/services';
import { QuizQuestion } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiz-questions',
  templateUrl: './quiz-questions.component.html',
  styleUrls: ['./quiz-questions.component.css']
})
export class QuizQuestionsComponent implements OnInit {

  // Take in questions and module number
  @Input() questions!: QuizQuestion[];
  @Input() moduleNumber!: number;
  @Input() questionsLimit = 10;

  // Quiz submitted event
  @Output() quizSubmitted = new EventEmitter<boolean>();

  // User answers and correct answer indexes
  answers: number[] = [];
  correctAnswers: number[] = [];

  // Used for percentage
  count!: any;
  percent!: any;
  status!: boolean;

  // Logical template variables
  showResults = false;
  quizStart: boolean = false;

  cheatQuiz = environment.courses.cheatQuizzes;

  constructor(private flashMessage: FlashMessagesService, private routeService: RouteService) { }

  cheatQuiz_click() {
    if (this.cheatQuiz && environment.courses.cheatQuizzes) {
      this.questions.slice(0, this.questionsLimit).forEach((q, index) => {
        this.updateChoice(q.correctAnswerIndex, index);
      });

      this.flashMessage.show('Filled in correct answers.', {
        cssClass: 'alert-success',
        timeout: 3000
      });
    }
  }

  // Needed  this to display option letters
  letterArray: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

  ngOnInit(): void {
  }

  // User updated their choice for the question
  updateChoice(choice: number, index: number) {

    // Push their answer index into the answer array at the question index
    this.answers[index] = choice;
  }

  // Submit quiz
  submitQuiz() {

    // Make sure quiz is full
    var complete = this.checkAnswerFulfillment();

    // Make sure they want to submit if there are unanswered questions
    if(complete || confirm("Some questions are unanswered, are you sure you want to submit?")) {

      // Scroll to top
      this.scrollToTop();

      // Create array of correct indexes
      this.questions.forEach(value => {
        this.correctAnswers.push(value.correctAnswerIndex);
      });

      // Update template to show results
      this.showResults = true;

      // Calculate number correct
      this.count = 0;
      for(let i = 0; i < this.correctAnswers.length; i++) {

        // A correct answer index should match the index in the correctAnswers array
        if (this.correctAnswers[i] == +this.answers[i]) {

          // Increase count correct
          this.count++;
        }
      }

      // Less than 10
      if (this.correctAnswers.length <= this.questionsLimit)
        this.percent = this.count * 100 / this.correctAnswers.length;

      // More than 10, only use 10
      else
        this.percent = this.count * 100 / this.questionsLimit;

      // Fail
      if(this.percent < 80) {
        this.status = false;
      }

      // Pass
      else {
        this.status = true;
      }

      // ============================
      // FOR DEVELOPMENT; always pass
      // ============================
      //this.status = true;
    }
  }

  // Check to see if there's any missing answers
  checkAnswerFulfillment() {
    var count = 0;
    this.answers.forEach(value => {
      count++;
    });

    // More than 10 questions
    if (this.questions.length > this.questionsLimit) {

      // Not all questions answered
      if(count != this.questionsLimit)
        return false;

      // All questions answered
      else
        return true;
      }

      // Less than 10 questions
      else {

      // Not all questions answered
      if(count != this.questions.length)
        return false;

      // All questions answered
        else
      return true;
    }
  }

  // Reset variables for retaking quiz
  retakeQuiz() {
    this.answers = [];
    this.showResults = false;
    this.correctAnswers = [];
    this.percent = 0;

    // Shuffle questions
    this.questions = this.shuffle(this.questions);

    // Scroll to top
    this.scrollToTop();
  }

  // Reset variables to return to module content to review
  returnToModule() {
    this.answers = [];
    this.showResults = false;
    this.correctAnswers = [];
    this.percent = 0;
    this.quizStart = false;
    this.quizSubmitted.emit(false);

    // Shuffle questions
    this.questions = this.shuffle(this.questions);

    // Scroll to top
    this.scrollToTop();
  }

  // Start quiz from start-page component
  startQuiz(valueEmitted: any){
    this.quizStart = valueEmitted;

    // Shuffle questions
    this.questions = this.shuffle(this.questions);

    // Scroll to top
    this.scrollToTop();
  }

  // Send passing quiz status in the module
  handleQuiz() {
    this.quizSubmitted.emit(true);
  }

  // Shuffle quiz
  shuffle(array: any) {
    let currentIndex = array.length,  randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  private scrollToTop() {
    setTimeout(() => this.routeService.scrollToTop());
  }
}
